import React from "react";
import { connect } from "react-redux";
import "./style.scss";

const ProgressBar = ({
  width = 160,
  percentDone = 0,
  customClassName
}) => {
  const right = Math.round(width - ((percentDone / 100) * width));

  return (
    <div className={`ProgressBar ${customClassName}`} style={{ width }}>
      <div className="ProgressBar__fill" style={{ right }} />
    </div>
  );
};

export default connect()(ProgressBar);
